/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompleteRecurringTaskInstanceRequest
 */
export interface CompleteRecurringTaskInstanceRequest {
    /**
     * 
     * @type {string}
     * @memberof CompleteRecurringTaskInstanceRequest
     */
    outcome: CompleteRecurringTaskInstanceRequestOutcomeEnum;
    /**
     * 
     * @type {number}
     * @memberof CompleteRecurringTaskInstanceRequest
     */
    evidenceCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CompleteRecurringTaskInstanceRequest
     */
    findingsUnresolved?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompleteRecurringTaskInstanceRequest
     */
    completionNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof CompleteRecurringTaskInstanceRequest
     */
    completedBy?: string;
}


/**
 * @export
 */
export const CompleteRecurringTaskInstanceRequestOutcomeEnum = {
    OnTimeWithEvidence: 'ON_TIME_WITH_EVIDENCE',
    OnTimeNoEvidence: 'ON_TIME_NO_EVIDENCE',
    LateClosed: 'LATE_CLOSED',
    LateWithFindings: 'LATE_WITH_FINDINGS',
    Overdue: 'OVERDUE'
} as const;
export type CompleteRecurringTaskInstanceRequestOutcomeEnum = typeof CompleteRecurringTaskInstanceRequestOutcomeEnum[keyof typeof CompleteRecurringTaskInstanceRequestOutcomeEnum];


/**
 * Check if a given object implements the CompleteRecurringTaskInstanceRequest interface.
 */
export function instanceOfCompleteRecurringTaskInstanceRequest(value: object): value is CompleteRecurringTaskInstanceRequest {
    if (!('outcome' in value) || value['outcome'] === undefined) return false;
    return true;
}

export function CompleteRecurringTaskInstanceRequestFromJSON(json: any): CompleteRecurringTaskInstanceRequest {
    return CompleteRecurringTaskInstanceRequestFromJSONTyped(json, false);
}

export function CompleteRecurringTaskInstanceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteRecurringTaskInstanceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'outcome': json['outcome'],
        'evidenceCount': json['evidenceCount'] == null ? undefined : json['evidenceCount'],
        'findingsUnresolved': json['findingsUnresolved'] == null ? undefined : json['findingsUnresolved'],
        'completionNotes': json['completionNotes'] == null ? undefined : json['completionNotes'],
        'completedBy': json['completedBy'] == null ? undefined : json['completedBy'],
    };
}

export function CompleteRecurringTaskInstanceRequestToJSON(json: any): CompleteRecurringTaskInstanceRequest {
    return CompleteRecurringTaskInstanceRequestToJSONTyped(json, false);
}

export function CompleteRecurringTaskInstanceRequestToJSONTyped(value?: CompleteRecurringTaskInstanceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'outcome': value['outcome'],
        'evidenceCount': value['evidenceCount'],
        'findingsUnresolved': value['findingsUnresolved'],
        'completionNotes': value['completionNotes'],
        'completedBy': value['completedBy'],
    };
}

